import React, { useState, useEffect } from "react";
import axios from 'axios';
import LineGraph from './LineGraph';
import { useParams } from 'react-router-dom';
import './App.css';
import { STATE_FIPS_TO_NAME } from './stateMappings';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { loadVariableSettings } from './services/variableService';

const Trends = () => {
    const [yearsData, setYearsData] = useState(null);
    const [selectedVariable, setSelectedVariable] = useState('citizen_percent');
    const [variables, setVariables] = useState([]);
    const { countyFIPS, countyName } = useParams();
    const navigate = useNavigate();

    // Load variables on component mount
    useEffect(() => {
        const allVariables = loadVariableSettings();
        const trendsVariables = allVariables.filter(v => v.showInTrends);
        setVariables(trendsVariables);
        
        // Set first available variable as selected if current selection isn't available
        if (trendsVariables.length > 0 && !trendsVariables.find(v => v.id === selectedVariable)) {
            setSelectedVariable(trendsVariables[0].id);
        }
    }, [selectedVariable]);

    const formatStateCounty = (stateCounty) => {
        return stateCounty.toString().padStart(5, '0');
    };

    useEffect(() => {
        const fetchDataForCounty = async () => {
            const formattedCountyFIPS = formatStateCounty(countyFIPS);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/db/county/${formattedCountyFIPS}`);
            setYearsData(response.data);
        };
    
        fetchDataForCounty();
    }, [countyFIPS]);

    const stateFips = formatStateCounty(countyFIPS).slice(0, 2);
    const stateName = STATE_FIPS_TO_NAME[stateFips];

    return (
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
            <Button 
                variant="contained" 
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/map')}
                sx={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    backgroundColor: '#1976d2',
                    '&:hover': {
                        backgroundColor: '#1565c0',
                    },
                    zIndex: 1000
                }}
            >
                Back to Map
            </Button>
            <div className="trends-container">
                <div style={{ marginTop: '80px' }}>
                    <h1>
                        {variables.find(v => v.id === selectedVariable)?.label} Over Time in {stateName}
                    </h1>
                    <div>
                        <label htmlFor="variableSelect">Select Variable: </label>
                        <select 
                            id="variableSelect" 
                            value={selectedVariable} 
                            onChange={(e) => setSelectedVariable(e.target.value)}
                        >
                            {variables.map(variable => (
                                <option key={variable.id} value={variable.id}>
                                    {variable.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    {yearsData && variables.length > 0 && (
                        <LineGraph 
                            data={yearsData} 
                            selectedVariable={selectedVariable}
                            variable={variables.find(v => v.id === selectedVariable)}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Trends;